import { CITIES } from '../../config';

/* ── Announcement bar ─────────────────────────────────────────────────── */
const AnnouncementBar = () => (
  <div className="pei-bar">
    <span>Cotiza en 2 minutos</span><span className="dot"></span>
    <span className="hide-sm">Sin papeleo, 100% digital</span><span className="dot hide-sm"></span>
    <span className="hide-sm">{CITIES}</span>
  </div>
);

export default AnnouncementBar;
